<template>
  <h4>ComTest.vue</h4>
  <p class="testColor">See console for output.</p>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      post: null,
    };
  },
  created() {
    this.fetchData();
    this.GetAllUsers();
  },
  methods: {
    fetchData() {
      fetch("weatherforecast")
        .then((r) => r.json())
        .then((json) => {
          console.log("------ fetchData Start -------");
          console.log("json: ", json);
          console.log("------ fetchData End -------");
          return;
        });
    },

    GetAllUsers() {
      let options = {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-type": "application/json;charset=UTF-8",
        },
      };

      fetch("api/User/SelAllUsers", options)
        .then((r) => {
          console.log("r.ok = ", r.ok);
          return r.json();
        })
        .then((json) => {
          console.log("------ GetAllUsers Start -------");
          console.log("json: ", json);
          console.log("------ GetAllUsers End -------");
          return;
        });
    },
  },
};
</script>

<style></style>
